export const PAYMENT_LINK_BANNER_ID = 'PAYMENT_LINK_BANNER_ID';
export const PERSONAL_MANAGER_BANNER_ID = 'PERSONAL_MANAGER_BANNER_ID';
export const MINIMAL_PAYMENT = 990;
export const MONTH_PRICE_FOR_PERSONAL_MANAGER = 5000;
